import React from "react";
import Text from "../atoms/Text";
import { formatCurrency } from "./ProfileShared";

export default function OrderHistoryProfile({
  orders,
  showPagination = false,
  currentPage = 1,
  pageCount = 1,
  onPageChange,
  onViewAll,
  onSelectOrder,
}) {
  return (
    <div
      className="order-history-profile"
      style={{
        border: "1px solid var(--gray1)",
        borderRadius: "8px",
        overflow: "hidden",
        backgroundColor: "var(--white)",
      }}
    >
      <div
        className="order-history-head"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "20px 24px",
        }}
      >
        <Text size="px20" weight="w500" color="gray9">
          {showPagination ? "Order History" : "Recent Order History"}
        </Text>
        {!showPagination ? (
          <button
            type="button"
            onClick={onViewAll}
            style={{
              border: "none",
              backgroundColor: "transparent",
              color: "var(--primary)",
              fontSize: "14px",
              fontWeight: 500,
              cursor: "pointer",
              fontFamily: "inherit",
              padding: 0,
            }}
          >
            View All
          </button>
        ) : null}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1.1fr 1fr 1.4fr 1fr 1fr",
          padding: "12px 24px",
          backgroundColor: "var(--gray05)",
        }}
      >
        {["Order ID", "Date", "Total", "Status", ""].map((heading) => (
          <Text
            key={heading}
            size="px12"
            weight="w500"
            color="gray5"
            extraStyles={{ textTransform: "uppercase", textAlign: "start" }}
          >
            {heading}
          </Text>
        ))}
      </div>

      {orders.map((order) => (
        <div
          className="order-history-row"
          key={order.id}
          style={{
            display: "grid",
            gridTemplateColumns: "1.1fr 1fr 1.4fr 1fr 1fr",
            padding: "15px 24px",
            borderTop: "1px solid var(--gray05)",
            alignItems: "center",
          }}
        >
          <Text
            size="px14"
            weight="w400"
            color="gray9"
            extraStyles={{ textAlign: "start" }}
          >
            {order.id}
          </Text>
          <Text
            size="px14"
            weight="w400"
            color="gray5"
            extraStyles={{ textAlign: "start" }}
          >
            {order.date}
          </Text>
          <Text
            size="px14"
            weight="w400"
            color="gray9"
            extraStyles={{ textAlign: "start" }}
          >
            {formatCurrency(order.total)} ({order.items?.length || 0} Products)
          </Text>
          <Text
            size="px14"
            weight="w400"
            color="gray5"
            extraStyles={{ textAlign: "start" }}
          >
            {order.status}
          </Text>
          <button
            type="button"
            onClick={() => onSelectOrder(order.id)}
            style={{
              border: "none",
              backgroundColor: "transparent",
              color: "var(--primary)",
              fontSize: "14px",
              fontWeight: 500,
              cursor: "pointer",
              fontFamily: "inherit",
              padding: 0,
              textAlign: "start",
            }}
          >
            View Details
          </button>
        </div>
      ))}

      {showPagination ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "12px",
            padding: "24px",
          }}
        >
          <button
            type="button"
            onClick={() => onPageChange(Math.max(1, currentPage - 1))}
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              border: "none",
              backgroundColor: "var(--gray05)",
              color: "var(--gray5)",
              cursor: "pointer",
            }}
          >
            {"<"}
          </button>
          {Array.from({ length: pageCount }, (_, index) => index + 1).map((page) => (
            <button
              key={page}
              type="button"
              onClick={() => onPageChange(page)}
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                border: "none",
                backgroundColor:
                  currentPage === page ? "var(--primary)" : "transparent",
                color: currentPage === page ? "var(--white)" : "var(--gray7)",
                cursor: "pointer",
              }}
            >
              {page}
            </button>
          ))}
          <button
            type="button"
            onClick={() => onPageChange(Math.min(pageCount, currentPage + 1))}
            style={{
              width: "32px",
              height: "32px",
              borderRadius: "50%",
              border: "1px solid var(--gray1)",
              backgroundColor: "var(--white)",
              color: "var(--gray7)",
              cursor: "pointer",
            }}
          >
            {">"}
          </button>
        </div>
      ) : null}
    </div>
  );
}
